import { DiscordIcon } from 'assets/icons/Social'
import React from 'react'

const CommunitySection = () => {
  return (
    <section className="py-12 flex flex-col items-center justify-center gap-4 mx-auto max-w-2xl lg:max-w-none text-left lg:text-center">
      <h2 className="text-3xl font-extrabold tracking-tight lg:text-4xl">
        Join our growing Discord Community
      </h2>
      <p className="text-base sm:text-lg lg:text-xl">
        Join and be a part of our active community, Participate and be a part of
        multiple events and active discussions. Play games, build startups and
        have a lot of fun
      </p>
      <div className="self-start md:self-center -mx-2.5">
        <a
          href="https://devsnest.in/r/tech-school"
          target="_blank"
          rel="noreferrer">
          <div className="text-base sm:text-lg py-2 px-6 bg-indigo-700 hover:bg-indigo-800 rounded cursor-pointer mx-2.5">
            <div className="flex items-center">
              <DiscordIcon className="h-5 w-5" />
              <span className="ml-2">Join Discord</span>
            </div>
          </div>
        </a>
      </div>
    </section>
  )
}

export default CommunitySection
